/// <amd-module name="Artifacts/FeedPicker/redux/Contracts" />

import { ComponentState } from "Artifacts/Root/constants";
import { IFeedIdentity } from "Artifacts/Root/types";

export interface IFeedPickerState {
  componentState: ComponentState;
  feeds: IFeedIdentity[];
  deletedFeeds: IFeedIdentity[];
}
